export default __webpack_public_path__ + "static/coach-ea4b339f228dd7dec41ce886830b4b8e.png";